import { useCallback, useEffect } from 'react';

import AuthPage from 'src/pages/AuthPage';
import AuthNoAccess from 'src/components/ui/AuthNoAccess';
import { useDocumentTitle } from 'src/hooks/useDocumentTitle';
import { authNoAccessProps } from '../mocks/authPage.mock';
import { getMe } from 'src/services/getMe';
import { getSafeReturnPath } from '../constants';
import { isUnauthorizedError } from 'src/utils/helpers/isUnauthorizedError';
import client from 'src/api/apollo/client';

const restoreSession = async () => {
	await client.clearStore();
	const me = await getMe({ fetchPolicy: 'network-only' });

	if (me) {
		window.location.assign(getSafeReturnPath(window.location));
		return true;
	}

	return false;
};

const AuthPageRoute = () => {
	useDocumentTitle('Нет доступа');

	const handleReload = useCallback(async () => {
		try {
			await restoreSession();
		} catch (error) {
			if (!isUnauthorizedError(error)) {
				console.error('Failed to restore session.', error);
			}
		}
	}, []);

	useEffect(() => {
		const onVisible = () => {
			if (document.visibilityState === 'visible') {
				handleReload();
			}
		};

		document.addEventListener('visibilitychange', onVisible);
		window.addEventListener('focus', handleReload);

		return () => {
			document.removeEventListener('visibilitychange', onVisible);
			window.removeEventListener('focus', handleReload);
		};
	}, [handleReload]);

	return (
		<AuthPage>
			<AuthNoAccess {...authNoAccessProps} onReload={handleReload} />
		</AuthPage>
	);
};

export default AuthPageRoute;
